var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.9996,
    cy: 23.9996,
    r: 22.4,
    fill: "#3898E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 15C19.0374 15 15 19.0374 15 24V27.7287C15 28.6503 15.8073 29.4 16.8 29.4H17.7C17.9387 29.4 18.1676 29.3052 18.3364 29.1364C18.5052 28.9676 18.6 28.7387 18.6 28.5V23.8713C18.6 23.6326 18.5052 23.4037 18.3364 23.2349C18.1676 23.0661 17.9387 22.9713 17.7 22.9713H16.8828C17.3832 19.4883 20.3802 16.8 24 16.8C27.6198 16.8 30.6168 19.4883 31.1172 22.9713H30.3C30.0613 22.9713 29.8324 23.0661 29.6636 23.2349C29.4948 23.4037 29.4 23.6326 29.4 23.8713V29.4C29.4 30.3927 28.5927 31.2 27.6 31.2H25.8V30.3H22.2V33H27.6C29.5854 33 31.2 31.3854 31.2 29.4C32.1927 29.4 33 28.6503 33 27.7287V24C33 19.0374 28.9626 15 24 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/SupportIcon.ed957530f715535d15d3d31d7c5ca854.svg";
export { ForwardRef as ReactComponent };